const getLowestAdultTravellerPrice = (travellerPrices) => {
    return travellerPrices
        .filter((price) => price.travellerType === "ADULT")
        .sort((a, b) => {
        const { units: aUnits, nanos: aNanos } = a.travellerPriceBreakdown.total;
        const { units: bUnits, nanos: bNanos } = b.travellerPriceBreakdown.total;
        return aUnits === bUnits ? aNanos - bNanos : aUnits - bUnits;
    })
        .find((price) => Boolean(price.travellerType));
};
export default getLowestAdultTravellerPrice;
